module.exports = __webpack_public_path__ + "img/img10.e3e45c70.jpg";